import { IDevice } from "../../../model/device/Device";
import { DateService } from "../../../service/DateService";

export interface TDevicePresentationModel {
  id: number;
  deviceId: string;
  appId: string;
  description: string;
  registrationDate: string;
}

const DevicePresentationModel = (data: IDevice): TDevicePresentationModel => {
  const registrationDate = DateService().formatWithoutTimezone(
    data.registrationDate
  );

  return {
    id: data.id,
    deviceId: data.deviceId,
    appId: data.appId,
    description: data.description,
    registrationDate
  };
};

export default DevicePresentationModel;
